export const VIBE_DATASET_BOOTSTRAP_PROMPT = `你现在要帮我完成 AIC（All In Context）业务数据资产目录登记：引导我提供 AIC 落地规划 Markdown 文档，找到其中的“数据资产清单”或“核心数据资产”表，把表格逐行整理成拟登记项目并在我确认后调用公司大接口。本次只保存项目目录元数据，不登记逻辑表和字段，不上传真实业务数据或附件。

开始前必须先准备文档：

- 先检查当前任务中是否已经有可读取的 AIC 规划 Markdown 附件、完整 Markdown 内容或本地绝对路径。
- 如果没有，停止后续操作，只回复让我上传 \`.md\` 文件或提供可读取的绝对路径；拿到文档前不要检查 API Key、不要调用接口、不要创建项目。
- Markdown 只提供给当前 Codex 做本地分析，不会作为附件或请求内容上传到公司大接口。大接口只能接收我确认后的项目元数据。
- 如果有多个文件或多个候选数据资产表，先列出文件名、章节、表名、列名和有效行数，让我选择要登记的表。

最重要的项目边界：

- 如果我提供数据资产清单或表格，每一行“数据资产”默认对应一个独立 AIC 项目。
- 先把目标表完整分析成“拟登记项目清单”，逐行展示源行号、名称、描述、数据 Owner、位置、部门、频率、敏感级、projectName 和处理方式，再让我一次确认后逐行创建。
- 用户确认后，每一行必须单独调用一次创建接口，不得把多行合并成一个项目请求。
- 如果某行看起来过于聚合或可能需要拆分，只标记为“需确认”并说明原因，不得未经确认自行编造子项目。
- 数据 Owner 和“现在在哪/当前入口/当前载体”必须按清单单元格原文保存，不要把 Owner 解析成当前 API Key 用户，也不要检查位置是否真实存在。
- 不要把目标周、验收状态、入池方式、替代方案、工作流或群清单额外创建成项目，也不要根据“46项”“126项”等数量编造未列出的项目。

必须遵守：

1. API Key 只能从当前环境变量 LECHUN_API_KEY 读取。不要让我把 API Key 粘贴到聊天中，不要输出、记录或保存它。
2. 如果当前环境变量中不存在 LECHUN_API_KEY，停止后续操作，并让我打开 https://portal.lechun.cc/portal/profile?tab=apikey，在页面表格下方按当前电脑系统复制环境配置命令：
   - Mac：打开“终端”（Terminal），粘贴 Mac 配置命令并按回车执行。
   - Windows：打开“命令提示符”（CMD），粘贴 Windows 配置命令并按回车执行。
   执行成功后，完全退出并重新打开 Codex，重新检查 LECHUN_API_KEY 已存在后再继续。
3. 使用请求头 \`X-API-Key: $LECHUN_API_KEY\` 调用；不要改用会触发网关接口权限校验的 \`X-Caller-Key\`：
   \`GET https://scmapi.lechun.cc/lechun-baseservice/vibeDataset/bootstrap/context\`
4. 为请求生成 UUID 并放入 \`X-Request-Id\`，失败时保留响应中的 requestId 便于技术人员排查。
5. 即使 HTTP 状态是 200，也必须检查 JSON；只有 \`status=200\` 且 \`success=true\` 才算成功。
6. 完整读取并严格执行响应 \`value.instruction\`，不能根据记忆使用旧步骤；服务端返回的最新版指令负责资产表识别、字段映射、预览确认、幂等恢复和逐行创建。
7. 只读取规划 Markdown 中的目录文字，不打开清单位置指向的 Excel、钉钉文档、群聊、URL、PDF 或业务系统，不上传原附件，不提交 Git，不直接连接数据库。
8. 项目创建成功就是当前阶段完成。严禁生成 Manifest，严禁调用 prepare、chunks 和 complete，严禁创建数据库物理表。
9. 最终汇报成功、复用、失败和跳过数量，并逐行列出源行号、项目 ID、名称、数据 Owner、位置、部门、频率和敏感级；明确说明只上传了确认后的项目元数据，Markdown 文件未上传，未登记表字段，未上传真实数据。`
